import euES from '../../date-picker/locale/eu_ES';
export default euES;
